import { useMutation } from 'query';
import { changeRequest } from 'common/services';
import type { ContactUsFormValues } from '../../contact-us';

export const useProgramChangeRequest = () =>
  useMutation<undefined, { data: ContactUsFormValues; programId: string }>({
    async mutationFn({ data, programId }) {
      /* eslint-disable @typescript-eslint/naming-convention -- Start: We missing correct application model in camelCase, we need to fix it */
      await changeRequest({
        kind: 'program_request_to_contact',
        meta: {
          invitation_phone: data.invitationPhone,
        },
        subject_id: programId,
        subject_type: 'Program',
      });
      /* eslint-enable @typescript-eslint/naming-convention -- End: We missing correct application model in camelCase, we need to fix it */

      return undefined;
    },
  });
